import { phoneHref, waLink } from "@/data/products";

export default function StickyCta() {
  return (
    <div className="sticky-cta" data-testid="sticky-cta">
      <a
        className="btn-furnace sticky-btn"
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
      >
        WHATSAPP FOR RATE
      </a>
      <a
        className="btn-furnace sticky-btn"
        href={phoneHref()}
        data-testid="sticky-call-button"
      >
        CALL NOW
      </a>
    </div>
  );
}
